module.exports = __webpack_public_path__ + "static/media/HB_lentilsalad3_edited.ebe73731.jpg";